/*
 * Copyright (c) Schrocken Inc.
 * Author: Nitin
 * File Description: Component to combine all login components
 */

import React from 'react';

import { Grid } from '@material-ui/core';
import AzureLogin from '../../common/AzureLogin';
import PingLogin from '../../common/PingLogin';
import ContactAdmin from '../../common/ContactAdmin';
import Login from './login';
import OpenPageHeaderwithMedia from '../../common/openPages/openPageHeaderwithMedia';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    // backgroundColor: 'red',
    // marginTop: 200,
    // // marginBottom:500,
    // [theme.breakpoints.down('xs')]: {
    //   marginBottom: 0,
    // },
  },
}));

function LoginIndex(props) {
  const classes = useStyles();
  return (
    <OpenPageHeaderwithMedia>
      <Grid container justify='center' className={classes.root}>
        <Login />
        {/* <AzureLogin /> */}
        <PingLogin />
        <ContactAdmin show />
      </Grid>
    </OpenPageHeaderwithMedia>
  );
}

export default LoginIndex;